// @flow

import React from 'react';
import { InputV2, InputConsumer } from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';
import FileField from '../Field/FileField';
import { toFullFileExtensionList } from '../Field/mimeTypeUtils';

const FileReferenceView = ({
  schema: getSchema,
  setValue,
  value
}: types.FileReferenceView) => {
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    className,
    context,
    contextValues,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    fieldName,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });

  return (
    <InputV2
      className={className}
      contextValues={contextValues}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      fieldName={fieldName}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <FileField
            accept={toFullFileExtensionList(schema?.contentMediaType)}
            context={context}
            embedded={embedded}
            id={id}
            name={name}
            required={required}
            schema={schema}
            value={value}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
FileReferenceView.displayName = 'FileReferenceView';

export default React.memo<types.FileReferenceView>(FileReferenceView);
